import styled from 'styled-components';

const NewsSectionStyle = styled.section`
	.news-list {
		margin-top: var(--customDistance2);
	}

	.file-animation {
		opacity: 0;
		transition: var(--trTime) ease-in var(--trTime);
	}

	.file-info-block {
		opacity: 0;
		transition: var(--trTime) ease-in calc(var(--trTime) * 1.5);
	}

	.file-inner-info-block {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		padding: var(--sp2x) 0;
		height: 100%;
	}

	.editor-wrapper {
		margin-top: var(--customDistance3);
	}

	.file-section,
	.file-container {
		height: 100%;
	}

	.video-cont {
		border-radius: var(--sp3x);
		overflow: hidden;
		backface-visibility: hidden;
		isolation: isolate;
		min-height: 100%;
	}

	.text-date {
		margin-left: auto;
		margin-top: var(--sp2x);
	}

	&.active {
		.file-animation,
		.file-info-block {
			opacity: 1;
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		.file-info-block {
			margin-top: var(--sp2x);
		}

		.file-inner-info-block {
			padding: 0;
		}

		.video-cont {
			--fileHeight: 60%;
		}
	}
`;

export default NewsSectionStyle;
